import { createContext, useContext } from 'react'

import { useReviewsState } from '../../hooks'

import type { ReviewsStateValue } from '../../hooks/useReviewsState'
import type { ReviewsProviderProps } from '../../types'

const ReviewsContext = createContext<ReviewsStateValue | undefined>(undefined)

/**
 * Thin Provider for reviews state
 * Calls useReviewsState composition hook
 */
export function ReviewsProvider({ children, productSku }: ReviewsProviderProps) {
  const value = useReviewsState(productSku)

  return <ReviewsContext value={value}>{children}</ReviewsContext>
}

export function useReviews() {
  const context = useContext(ReviewsContext)
  if (context === undefined) {
    throw new Error('useReviews must be used within a ReviewsProvider')
  }
  return context
}
